import { useMutation } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { type Export, type ExportRequest } from '@/types/export';
import { createExport } from '@/services/export.service';

type ExportMutationError = Record<string, unknown> & { status: number };

type Options = {
  onSuccess?: (data: Export) => void;
  onError?: (error: ExportMutationError) => void;
};

export function useCreateExportMutation({ onSuccess, onError }: Options = {}) {
  const createExportFn = useAuthenticatedQueryFn(createExport);

  return useMutation<Export, ExportMutationError, ExportRequest>({
    mutationFn: (request: ExportRequest) => createExportFn({ ...request, variantIds: request.variantIds ?? [] }),
    onSuccess,
    onError,
  });
}
